import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_VALIDATE_SUPPORTING_DOCUMENT_FILE_SIZE } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ValidateSupportingDocumentFileSizeRequest {
  uuidList: (string | undefined)[];
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostValidateSupportingDocumentFileSize = ({ onSuccess, onError }: Input = {}) => {
  const postValidateSupportingDocumentFileSize = async (
    reqBody: ValidateSupportingDocumentFileSizeRequest
  ) => {
    const res = await axiosClient.post(POST_VALIDATE_SUPPORTING_DOCUMENT_FILE_SIZE, reqBody);
    return res.data;
  };

  return useCustomMutation(postValidateSupportingDocumentFileSize, {
    onSuccess,
    onError,
  });
};
